import React from "react";
import chaanPic from "../../images/chaanPic.png";
import geraldPic from "../../images/geraldPic.png";
import davidPic from "../../images/davidPic.png";
import philipPic from "../../images/philipPic.png";
import { colors } from "../../constants/colors";
const MemberProfile = ({ image, name, companyRole, bio, aosTime }) => {
  const nameId = name.toLowerCase().split(" ").join("-");
  return (
    <div
      id={nameId}
      className="member-row flex-row px-5"
      data-aos="fade-left"
      data-aos-delay={{ aosTime }}
    >
      <div className="d-flex no-gutters text-center align-items-center flex-column col-xs-12 col-md-4 col-sm-12">
        <img
          style={{ height: "100px", width: "100px", borderRadius: "50%" }}
          src={image}
          alt={name}
        />
        <h5 style={{ color: colors.gencBlue }}>
          <b>{name}</b>
        </h5>
        <p style={{ color: colors.gencBlue }}>{companyRole}</p>
      </div>

      <div className="text-left col-xs-12 col-md-8 col-sm-12">
        <p style={{ color: colors.gencBlack }}>{bio}</p>
      </div>
    </div>
  );
};
const memberProfiles = [
  {
    image: chaanPic,
    name: "Bill Beard",
    companyRole: "CTO & Hybrid Blockchain Evangelist Lead",
    bio:
      "Former flight instructor and HP labs microprocessor engineer Chaan has been in the USA since 1998 and has worked for most technology companies in roles from engineer to CTO across 5 continents.\n Interests include chess, ancient civilizations and cooking as an art while drinking wines of the world.\nEducated as a telecommunications engineer in South Africa and the UK. Chaan has a wide range of skills and is a key team player in any organization he works with. \n Sense of humor mandatory to get the most out of him and his vast experience in many subject areas.",
  },
  {
    image: davidPic,
    name: "David Zhang",
    companyRole: "VP of Engineering & DevOps Lead",
    bio: `With over 16 years experience in internet Security industry, Software Engineering as a principal software architect and DevOps engineer, David has in-depth knowledge and experiences in Kubernetes/rancher/helm, VMware, Capistrano, Jenkins, CICD, monitoring/Nagios/New Relic, Splunk, Python, Java, Node JS, Salt/ansible/puppet, Spacewalk, Oracle/MariaDB/MySQL/Postgresql, Unix admin, Jira/confluence, REST API, F5 load balancer. In his spare time,  David enjoys skiing and teaches other engineers in Infrastructure Buildup, CICD, Private Cloud, and Data Center Management.
        `,
  },
  {
    image: geraldPic,
    name: "Gerald Gular",
    companyRole: "VP of Business & Strategist Lead",
    bio: `Gerald Gular has over 20+ years as strategic development specialist in the technology and finance sectors as banking executive from JP Morgan Merrill Lynch and Bank of America  Gerald focuses on identifying new development opportunities and has
        repeatedly developed strategic customer and investor relationships for security,networking and storage companies. In these roles he has worked with major organizations including the US Department of Defense, Aeris,
        Boeing, IDS Group, Darpa, Cisco, NSA, Mitchell International, HP, TEAC Aerospace, The UK Ministry of Defence, Logica Plc, the Defense Ministry of the Netherlands SingaporeTechnologies as well as raised investment from Mayfield Ventures and Texas
        Pacific,Woodside Capital 100+million 
         
        Describing himself as a “latent entrepreneur” Gerald brings to his development
        work the ability to identify and close opportunities and to execute with the same
        determination and mental toughness that he developed as a junior tennis champion and collegiate player.
        `,
  },
  {
    image: philipPic,
    name: "Philip Tran",
    companyRole: "Founder & CEO",
    bio: `Philip has been a serial entrepreneur since starting his own business at the age of 19 and has spent the last 30 years evolving. This has driven him to continue pursuing his dream of building the technology of the future. After spending years developing new technology and filing for patents, he has hand-on experience in the search, media and data security space. This drove him to develop his next invention in the field of data security known as Hybrid Blockchain and a new protocol to store sensitive user data. Philip was a lecturer at Cal State Monterey Bay, among founding team members of two silicon valley tech startups, among the  core team members and an architect of a data computing network called Angelo Network, and a senior member of an engineering team of a Fortune-500 company worked on challenging problems in web security. He is now working with talented and passionate team members at GenC Labs evangelizing the Hybrid Blockchain and bringing efficiency to the healthtech segment.

    Philip finds inspiration from helping people grow as they pursue health and wellness. Philip enjoys studying (and consuming) superfoods to help maintain his peak performance. He loves to volunteer at tennis tournaments both as a player and as an organizer
    .`,
  },
  // {
  //   image: philipPic,
  //   name: "Philip Tran",
  //   companyRole: "Founder CEO",
  //   bio: `Philip has been a serial entrepreneur since starting his own business at the age of 19 and has spent the last 30 years evolving. This has driven him to continue pursuing his dream of building the technology of the future. After spending years developing new technology and filing for patents, he has hand-on experience in the search, media and data security space. This drove him to develop his next invention in the field of data security known as Hybrid Blockchain and a new protocol to store sensitive user data. Philip was a lecturer at Cal State Monterey Bay, among founding team members of two silicon valley tech startups, among the  core team members and an architect of a data computing network called Angelo Network, and a senior member of an engineering team of a Fortune-500 company worked on challenging problems in web security. He is now working with talented and passionate team members at GenC Labs, Inc. evangelizing the Hybrid-Blockchain technology and bringing efficiency to the healthcare segment.

  //     Philip finds inspiration from helping people grow as they pursue health and wellness. Philip enjoys studying (and consuming) superfoods to help maintain his peak performance. He loves to volunteer at tennis tournaments both as a player and as an organizer
  //     .`,
  // },
];
export const TeamMembers = () => {
  let aosTime = 0;
  return (
    <section
      // data-aos="zoom-in-down"
      className="team-members d-flex flex-column justify-content-center text-center p-5"
      id="team-members"
    >
      <div
        className="team-members-details"
        style={{ paddingRight: "12vw", paddingLeft: "12vw" }}
      >
        <h1
          style={{
            color: colors.gencBlue,
          }}
        >
          Meet Our Team
        </h1>
        <p>
          Innovation creates OPPORTUNITY. Quality creates DEMANDS. But it takes
          TEAMWORK to make it happen.
        </p>
      </div>
      <div className="team-members-bios p-5">
        {memberProfiles.map((member) => {
          aosTime += 250;
          return (
            <MemberProfile key={member.name} {...member} aosTime={aosTime} />
          );
        })}
      </div>
    </section>
  );
};
